<template>
  <div class="ticket-users-title-container">
    <template v-if="target === 'conversation'">
      <div v-if="ticket && ticket.assignedEmployees && !ticket.unreadMessages" class="ticket-users">
        <div class="user-avatar-stacked-container">
          <user-avatar
            v-for="user in ticket.assignedEmployees"
            :key="user.id"
            :name="user.name"
            :online="user.online"
            :avatar="user.avatar"
            :size="target === 'tickets' ? '24px' : '36px'"
          />
        </div>
      </div>
      <div class="ticket-title" :class="[{ 'small-title': target && target === 'tickets' }]">
        <span>
          {{ getTitle }}
        </span>
      </div>
    </template>

    <template v-if="target === 'tickets'">
      <div v-if="ticket && ticket.unreadMessages" class="ticket-unread-messages-counter">
        {{ ticket.unreadMessages }}
      </div>
      <div v-else-if="ticket && ticket.order" class="ticket-avatar-order">
        <b-icon icon="shopping-cart" />
      </div>
      <user-avatar
        v-else
        :name="image.name"
        :online="image.online"
        :avatar="image.avatar"
        :size="target === 'tickets' ? '24px' : '36px'"
      />
      <div class="ticket-title" :class="[{ 'small-title': target && target === 'tickets' }]">
        <span>
          {{ ticket.title }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import UserAvatar from '~/marketplace-front-core/components/shared/UserAvatar'

export default {
  name: 'NewMessengerConversationHeader',
  components: { UserAvatar },
  props: {
    ticket: {
      type: Object,
      default: null
    },
    target: {
      type: String,
      default: ''
    }
  },
  computed: {
    image () {
      return {
        name: this.ticket.title,
        online: false,
        avatar: this.ticket.avatar
      }
    },
    getTitle () {
      if (this.ticket.assignedEmployees.length) {
        let title = ''
        this.ticket.assignedEmployees.forEach((user, index) => {
          if (index === 0) {
            title = user.name
          } else {
            title = title.concat(', ', user.name)
          }
        })
        return title
      } else {
        return this.ticket.title
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-users-title-container {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;

  .ticket-avatar-order {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid rgba($primary, 0.16);
    :deep(.icon) {
      width: 20px;
      height: 20px;
      color: rgba($primary, 0.75);
      i {
        font-size: 0.75rem !important;
      }
    }
  }

  .ticket-users {
    display: flex;

    .user-avatar-stacked-container {
      display: flex;
    }
  }

  .ticket-unread-messages-counter {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    background-color: rgba($primary, 0.16);
    color: $primary;
    border-radius: 13px;
    font-size: 12px;
  }

  .ticket-title {
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;

    &.small-title {
      font-size: 14px;
      font-weight: 400;
    }
  }
}</style>
